<template>
  <el-container class="hotellist-main" id="main">
    <publicHeader @setCollapse="setCollapse" @getPermissions="getPermissions"></publicHeader>
    <div class="main-content">
      <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
      <div class="content">
        <slot>
          <el-main>
            <div class="home-center">
              <div class="search">
                <div class="search-info">
                  <div class="hotellist-region el-input el-input--large el-input--suffix" :style="{'width': `${regionSearchWidth}px`}">
                    <el-input placeholder="Booking reference" v-model="orderno" @input="ordernoInput"></el-input>
                  </div>
                  <div class="search-status el-input el-input--large el-input--suffix">
                    <el-select style="width:300px;" v-model="orderStatus" filterable>
                      <el-option v-for="(item, id) in statusList" :key="id" :label="item" :value="id" class="option-item">{{item}}</el-option>
                    </el-select>
                  </div>
                  <div class="search-status el-input el-input--large el-input--suffix">
                    <el-select style="width:300px;" v-model="dateType" filterable :disabled="!showStatus">
                      <el-option v-for="(item, id) in dateTypeList" :key="id" :label="item" :value="id" class="option-item">{{item}}</el-option>
                    </el-select>
                  </div>
                  <div class="hotellist-date-all" @click="dateSearchShow($event)" style="float: left;margin-right: 5px;" data-index="date-pc">
                    <div class="el-date-editor el-range-editor el-input__inner hotellist-date hotellist-date1 el-date-editor--daterange" style="padding:0px;" :class="{'hotellist-date-show':hotelDateSearchShow, 'no-date': !showDate}" data-index="date-pc">
                      <i class="el-input__icon el-range__icon input-date-icon" style="background-position: center center;padding: 0px 10px;"  data-index="date-pc"></i>
                      <div>
                        <div class="hotellist-date-start hotellist-date-start-left" data-index="date-pc">
                          <div class="hotellist-date-start-date" :class="{'no-text-back': !showDate}" data-index="date-pc">{{checkDateWeek.date[0]}}</div>
                          <div class="hotellist-date-start-week" :class="{'no-text-back': !showDate}" data-index="date-pc">{{checkDateWeek.week[0]}}</div>
                        </div>
                        <div class="hotellist-date-line" data-index="date-pc">-</div>
                        <div class="hotellist-date-end" data-index="date-pc">
                          <div class="hotellist-date-end-date" :class="{'no-text-back': !showDate}" data-index="date-pc">{{checkDateWeek.date[1]}}</div>
                          <div class="hotellist-date-end-week" :class="{'no-text-back': !showDate}" data-index="date-pc">{{checkDateWeek.week[1]}}</div>
                        </div>
                      </div>
                    </div>
                    <div data-index="date-pc" v-show="showDate">
                      <!-- <el-date-picker v-model="checkDate" type="daterange" align="right" unlink-panels prefix-icon="input-date-icon" :start-placeholder="$t('startIn')" :end-placeholder="$t('endOut')" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" class="hotellist-date" popper-class="hotellist-date-time-show" :clearable="dateClearable" ref="hiddenDatePicker" :append-to-body="false" style="position: absolute;height: 0px; background: rgb(0,0,0,0);bottom: 5px; border: 0px; right: 46%" data-index="date-pc"></el-date-picker> -->
                      <el-date-picker v-model="checkDate" type="daterange" align="right" unlink-panels prefix-icon="input-date-icon" :start-placeholder="$t('startIn')" :end-placeholder="$t('endOut')" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" class="hotellist-date" popper-class="hotellist-date-time-show" :clearable="dateClearable" ref="hiddenDatePicker" style="position: absolute;height: 0px; background: rgb(0,0,0,0);bottom: 5px; border: 0px;" data-index="date-pc"></el-date-picker>
                    </div>
                  </div>
                  <el-button class="input_button booknow_button" style="margin-right: 5px !important; float: left;margin-left:0 !important;" id="inputButtonPc" @click="searchOrderNo">{{$t('search')}}</el-button>
                  <el-button class="input_button white_button" style="float: left;margin-right: 5px !important; float: left;margin-left:0 !important;" id="inputButtonPc" @click="clearParams">Clear</el-button>
                  <el-button class="input_button booknow_button" style="float: left;margin-left:0 !important;" id="inputButtonPc" @click="exportData">Export</el-button>
                </div>
              </div>
              <div class="trip-list" :style="heightCss">
                <el-skeleton animated :loading="listShow">
                  <template slot="template">
                    <div class="triplist">
                      <div class="width-orderno-info"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div class="width-creation-info"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div class="list-hotel-info"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div class="guest-info"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div class="check-info"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div class="price-info"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div class="status-info"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div class="view-info"></div>
                    </div>
                  </template>
                  <template>
                    <el-card :body-style="{ padding: '0px' }">
                      <div class="triplist">
                        <div class="width-orderno-info">Booking reference</div>
                        <div class="width-creation-info">Creation time</div>
                        <div class="list-hotel-info">Hotel</div>
                        <div class="guest-info">Guest name</div>
                        <div class="check-info">Checkin-Checkout</div>
                        <div class="price-info">Price</div>
                        <div class="status-info">Status</div>
                        <div class="view-info"></div>
                      </div>
                    </el-card>
                  </template>
                </el-skeleton>
                <el-skeleton :count="10" animated :loading="listShow">
                  <template slot="template">
                    <div class="hotel-info">
                      <div class="width-orderno-info"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="width-creation-info"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="list-hotel-info"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="guest-info"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="check-info"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="price-info"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="status-info"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div class="view-info"><el-skeleton-item variant="text" style="font-size: 13px; width: 100px; height: 30px;margin: 10px 0; float: right;" class="template-info-text" /></div>
                    </div>
                  </template>
                  <template>
                    <div class="hotel-info" v-for="(value, key) in listInfo" :key="key" v-show="!tripEmptyShow">
                      <div class="width-orderno-info" style="height: 60px;">{{value.orderno}}&nbsp;</div>
                      <div class="width-creation-info" style="height: 60px;">{{value.create_time}}</div>
                      <div style="width: 22%;height: 60px; padding-right:1%; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        <el-tooltip class="item cancel-title-data-cont" effect="dark" :content="value.hotelname" placement="top-start" v-tooltipHide>
                          <span>{{value.hotelname}}</span>
                        </el-tooltip>
                      </div>
                      <div class="guest-info" style="height: 60px; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        <el-tooltip class="item cancel-title-data-cont" effect="dark" :content="value.username" placement="top-start" v-tooltipHide>
                          <span>{{value.username}}</span>
                        </el-tooltip>
                      </div>
                      <div class="check-info" style="height: 40px; line-height: 20px; margin: 10px auto;">
                        {{value.checkin_val}}<br>{{value.checkout_val}}
                      </div>
                      <div class="price-info" style="height: 60px; ">{{value.currency}}{{value.totalprice}}</div>
                      <div class="status-info" style="height: 60px;" v-if="value.status_val === ''"></div>
                      <div class="status-info" style="height: 60px; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-else>
                        <el-tooltip class="item cancel-title-data-cont" effect="dark" :content="value.status_val" placement="top-start" v-tooltipHide>
                          <a style="height:100%;color: rgb(217, 0, 27);" v-if="['4', 4, '7', 7, '5', 5].includes(value.order_status)">{{value.status_val}}</a>
                          <a style="height:100%;color: #F59A23;" v-else-if="['1', 1].includes(value.order_status)">{{value.status_val}}</a>
                          <a style="height:100%;" v-else>{{value.status_val}}</a>
                        </el-tooltip>
                      </div>
                      <div class="view-info" style="height: 60px;">
                        <button type="button" class="white_button view_button" @click="gotoDetail(value.order_status, value.orderno, source, value.pay_status, key)">View</button>
                      </div>
                    </div>
                    <div style="height: 140px;" v-show="!tripEmptyShow"></div>
                    <div class="hotel-info" style="width: 100%; text-align: center;" v-show="tripEmptyShow">
                      <img src="/static/img/account/empty.png" style="width: 160px; height: 160px; margin-top: 80px;opacity: 0.25;">
                      <div class="empty-txt">You have no bookings~</div>
                    </div>
                  </template>
                </el-skeleton>
                <div class="account-data-page" v-show="!listShow && !tripEmptyShow">
                  <el-pagination background :page-size="pageSize"  @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="7" layout="prev, pager, next" :total="listTotal" :current-page="currentPage" > </el-pagination>
                </div>
              </div>
            </div>
          </el-main>
        </slot>
        <publicFooter :source="source"></publicFooter>
      </div>
    </div>
    <publicMask :fullscreenLoading="fullscreenLoading"></publicMask>
  </el-container>
</template>

<script scoped>
import { getTripList, exportData } from '@/request/order.js'
import publicFooter from '@/components/public/publicFooter'
import publicSearch from '@/components/public/publicSearch'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
import publicMask from '@/components/public/publicMask'
export default {
  name: 'myTrip',
  components: {
    publicFooter,
    publicHeader,
    publicSearch,
    publicMenu,
    publicMask
  },
  props: [],
  data () {
    return {
      dateSearch: false,
      activeIndex: 0,
      checkDate: [],
      checkDateWeek: {'date': ['', ''], 'week': ['', '']},
      timeout: null,
      dateClearable: false,
      pickerOptions: '',
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      hotelDateSearchShow: false,
      star: '',
      end: '',
      addrDateTime: '',
      source: this.common.sourceSet(),
      isCollapse: this.common.collapseSet(),
      contentWidth: document.body.clientWidth - 74,
      personWidth: (document.body.clientWidth - 74) * 0.2182 - 10,
      mainMinHeight: document.documentElement.clientHeight - 245,
      heightCss: {'min-height': '500px'},
      radioColor: ' rgba(241, 81, 27, 1)',
      orderno: '',
      orderStatus: 'all',
      statusList: {'all': 'All status', 'unpaid': 'Unpaid', 'Pending': 'Pending', 'Confirmed': 'Confirmed', 'PendingCancellation': 'Pending Cancellation', 'Cancelled': 'Cancelled', 'cancelcharges': 'Cancelled (charges)', 'Rejected': 'Rejected'},
      dateType: 'create',
      dateTypeList: {'all': 'All', 'create': 'Creation date', 'check': 'Checkin date'},
      showDate: true,
      showStatus: true,
      listInfo: {},
      currentPage: 1, // 当前默认显示第几页
      listTotal: 0, // 分页总条数
      pageSize: 20, // 每页显示多少条数据，记住这里一定要是10的倍数，不然无效
      listShow: true,
      tripEmptyShow: false,
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''},
      regionSearchWidth: '',
      screenWidth: '',
      isSearch: false,
      fullscreenLoading: false
    }
  },
  created: function () {
    localStorage.removeItem('LoginWebsiteAddress')
    // 获取当前日期
    let checkin = this.$route.query.checkin
    let checkout = this.$route.query.checkout
    if (checkin !== undefined && checkin !== null && checkin !== 'NAN-NAN-NAN' && checkout !== undefined && checkout !== null && checkout !== 'NAN-NAN-NAN' && this.isSearch === true && this.dateType !== 'all') {
      this.checkDate.push(checkin)
      this.checkDate.push(checkout)
    } else {
      let d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth()
      var tian = d.getDate()
      var dayNum = new Date(year, parseInt(month) + 1, 0).getDate()
      var startDate = tian
      var endDate = tian + 1
      var startMonth = month
      var endMonth = month
      var startYear = year
      var endYear = year
      if (startDate > dayNum) {
        startDate = parseInt(startDate) - parseInt(dayNum)
        startMonth += 1
      }
      if (endDate > dayNum) {
        endDate = parseInt(endDate) - parseInt(dayNum)
        endMonth += 1
      }
      if (startMonth >= 12) {
        startMonth = 0
        startYear += 1
      }
      if (endMonth >= 12) {
        endMonth = 0
        endYear += 1
      }
      var monthStartSelect = (startMonth + 1) < 10 ? '0' + (startMonth + 1).toString() : (startMonth + 1).toString()
      var monthEndSelect = (endMonth + 1) < 10 ? '0' + (endMonth + 1).toString() : (endMonth + 1).toString()
      var startDateSelect = startDate < 10 ? '0' + startDate.toString() : startDate.toString()
      var endDateSelect = endDate < 10 ? '0' + endDate.toString() : endDate.toString()
      this.checkDate.push(startYear + '-' + monthStartSelect + '-' + startDateSelect)
      this.checkDate.push(endYear + '-' + monthEndSelect + '-' + endDateSelect)
    }
    let nowcurrentPage = this.$route.query.currentPage
    if (/^\d+$/.test(parseInt(nowcurrentPage))) {
      this.currentPage = parseInt(nowcurrentPage)
    }
    let orderno = this.$route.query.orderno
    if (orderno !== undefined && orderno !== 'undefined') {
      this.orderno = orderno
    }
    let orderStatus = this.$route.query.orderStatus
    if (orderStatus !== undefined && orderStatus !== 'undefined') {
      this.orderStatus = orderStatus
    }
    let dateType = this.$route.query.dateType
    if (dateType !== undefined && dateType !== 'undefined') {
      this.dateType = dateType
    }
    if (this.isSearch === true) {
      if (checkin !== undefined && checkin !== 'undefined') {
        this.checkin = checkin
      }
      if (checkout !== undefined && checkout !== 'undefined') {
        this.checkout = checkout
      }
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth <= 1500) {
      this.screenWidth = 1500
    }
    this.regionSearchWidth = this.screenWidth - 754 - ((this.screenWidth - 124) * 0.21)
    console.log('regionSearchWidth1', this.regionSearchWidth)
    this.heightCss = {'min-height': this.mainMinHeight + 'px'}
    this.source = this.common.sourceSet()
    var source = this.common.sourceSet()
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      source = this.$route.query.source
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime > sourceExpires) {
          localStorage.removeItem('source')
          localStorage.removeItem('sourceExpiresAt')
        } else {
          // 避免手动干预删除或者修改localStorage
          if (source === '' || source === undefined || source === null) {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          } else {
            this.source = source
            this.common.sourceSet(source)
          }
        }
      }
    }
    if (this.source === '' || this.source === undefined || this.source === null) {
      let locationHref = window.document.location.href
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
    var checkin = this.$route.query.checkin
    var checkout = this.$route.query.checkout
    if (checkin !== '' && checkin !== undefined && checkout !== '' && checkout !== undefined) {
      this.checkDate['0'] = checkin
      this.checkDate['1'] = checkout
    }
    // 下拉框关闭
    document.addEventListener('click', this.bodyCloseMenus)
    this.getList(this.currentPage)
  },
  watch: {
    checkDate: function (n, o) {
      this.checkDateWeek = {}
      this.checkDate = n
      let startDate = new Date(n[0].replace(/-/g, '/'))
      let startY = startDate.getFullYear()
      let startM = ((startDate.getMonth() + 1) < 10) ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)
      let startMen = startDate.getMonth()
      let startD = (startDate.getDate() < 10) ? '0' + startDate.getDate() : startDate.getDate()
      let startW = startDate.getDay()

      let endDate = new Date(n[1].replace(/-/g, '/'))
      // 如果开始日期和结束日期选择了同一天，则结束日期=开始日期+1天.
      if (n[0] === n[1]) {
        var endDateStr = startDate.getDate() + 1

        var newStartM = Number(startM) + 1
        var newStartY = startY
        if (newStartM > 12) {
          newStartM = 1
          newStartY = Number(startY) + 1
        }

        var nextMonthFirstDay = new Date(newStartY, Number(newStartM) - 1, 1)
        var lastDayOfMonth = new Date(nextMonthFirstDay - 1)
        var endMaxDate = lastDayOfMonth.getDate()

        if (endDateStr <= endMaxDate) {
          endDate.setDate(endDateStr)
        } else {
          endDate = new Date(newStartY, Number(newStartM) - 1, 1)
        }
        console.log('开始日期与结束日期选择了同一天，重置结束日期')
        console.log(endDate)
      }
      let endY = endDate.getFullYear()
      let endM = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
      let endMen = endDate.getMonth()
      let endD = (endDate.getDate() < 10) ? '0' + endDate.getDate() : endDate.getDate()
      let endW = endDate.getDay()

      // 显示
      if (this.checkDate['1'] !== undefined) {
        this.checkDate['1'] = endY + '-' + endM + '-' + endD
      }

      var startYmd = ''
      var endYmd = ''
      var startwkstr = ''
      var endwkstr = ''
      if (this.language === 'en') {
        // Sep 15, 2022
        if (this.common.isMobile() === false) {
          startYmd = this.common.monthEn[startMen] + ' ' + startD + ', ' + startY
          endYmd = this.common.monthEn[endMen] + ' ' + endD + ', ' + endY
          startwkstr = this.common.weekPcEn[startW]
          endwkstr = this.common.weekPcEn[endW]
        } else {
          startYmd = this.common.monthEn[startMen] + ' ' + startD
          endYmd = this.common.monthEn[endMen] + ' ' + endD
          startwkstr = this.common.weekEn[startW]
          endwkstr = this.common.weekEn[endW]
        }
      } else {
        if (this.common.isMobile() === false) {
          startYmd = startY + '年' + startM + '月' + startD + '日'
          endYmd = endY + '年' + endM + '月' + endD + '日'
          startwkstr = this.common.weekZh[startW]
          endwkstr = this.common.weekZh[endW]
        } else {
          startYmd = startM + '月' + startD + '日'
          endYmd = endM + '月' + endD + '日'
          startwkstr = this.common.weekMobileZh[startW]
          endwkstr = this.common.weekMobileZh[endW]
        }
      }

      this.checkDateWeek.date = []
      this.checkDateWeek.date.push(startYmd)
      this.checkDateWeek.date.push(endYmd)

      this.checkDateWeek.week = []
      this.checkDateWeek.week.push(startwkstr)
      this.checkDateWeek.week.push(endwkstr)

      this.hotelDateSearchShow = false
    },
    addrDateTime: function (newTime, oldTime) {
      var addrTime = newTime + ' 00:00:00'
      this.pickerOptions = {
        disabledDate (date) {
          return date.getTime() < new Date(addrTime).getTime()
        }
      }

      const newdate = new Date(newTime)
      newdate.setDate(newdate.getDate() + 1)
      const newDateStr = newdate.toISOString().split('T')[0]

      this.checkDate = []
      this.checkDate.push(newTime)
      this.checkDate.push(newDateStr)
    },
    screenWidth: {
      handler: function (val) {
        this.regionSearchWidth = this.screenWidth - 754 - ((this.screenWidth - 124) * 0.21)
        console.log('regionSearchWidth', this.regionSearchWidth)
      }
    },
    dateType: function (n, o) {
      if (n === 'all' || this.orderno !== '') {
        this.showDate = false
      } else {
        this.showDate = true
      }
    },
    orderno: function (n, o) {
      if (n !== '') {
        this.showDate = false
        this.dateType = 'all'
        this.showStatus = false
      } else {
        this.showStatus = true
        if (this.dateType === 'all') {
          this.showDate = false
        } else {
          this.showDate = true
        }
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.bodyCloseMenus)
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.screenWidth = document.body.clientWidth
      if (this.screenWidth <= 1500) {
        this.screenWidth = 1500
      }
      this.regionSearchWidth = this.screenWidth - 754 - ((this.screenWidth - 124) * 0.21)
    },
    getPermissions (value) {
      this.allPermissions = value
    },
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 260
      } else {
        this.contentWidth = document.body.clientWidth - 74
      }
      this.personWidth = (this.contentWidth * 0.2182) - 10
    },
    closepopEven: function (type) {
      if (type === 'dateSearch') {
        this.dateSearch = false
      }
    },
    getCheckDate: function (val) {
      this.checkDate = val
    },
    dateSearchShow: function (e) {
      if (this.showDate === false) {
        return false
      }
      var that = this
      this.$refs.hiddenDatePicker.$el.click(function (e) {
        this.$emit('pick', that.checkDate)
      })
      if (this.hotelDateSearchShow === false && this.showDate === true) {
        this.hotelDateSearchShow = true
      }
    },
    bodyCloseMenus: function (node) {
      if (node.target.getAttribute('data-index') !== 'date-pc') {
        if (this.hotelDateSearchShow === true) {
          this.hotelDateSearchShow = false
        }
      }
    },
    // 分页 size-change  pageSize 改变时会触发 每页条数
    handleSizeChange (val) {
      this.pageSize = val
    },
    // current-change  currentPage 改变时会触发  当前页
    async handleCurrentChange (val) {
      this.currentPage = val
      this.getList(val)
    },
    searchOrderNo () {
      this.getList(this.currentPage, 'search')
    },
    clearParams () {
      this.orderno = ''
      this.orderStatus = 'all'
      this.dateType = 'create'
      this.showDate = true
      this.showStatus = true
      this.checkDate = []
      // 获取当前日期
      let d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth()
      var tian = d.getDate()
      var dayNum = new Date(year, parseInt(month) + 1, 0).getDate()
      var startDate = tian
      var endDate = tian + 1
      var startMonth = month
      var endMonth = month
      var startYear = year
      var endYear = year
      if (startDate > dayNum) {
        startDate = parseInt(startDate) - parseInt(dayNum)
        startMonth += 1
      }
      if (endDate > dayNum) {
        endDate = parseInt(endDate) - parseInt(dayNum)
        endMonth += 1
      }
      if (startMonth >= 12) {
        startMonth = 0
        startYear += 1
      }
      if (endMonth >= 12) {
        endMonth = 0
        endYear += 1
      }
      var monthStartSelect = (startMonth + 1) < 10 ? '0' + (startMonth + 1).toString() : (startMonth + 1).toString()
      var monthEndSelect = (endMonth + 1) < 10 ? '0' + (endMonth + 1).toString() : (endMonth + 1).toString()
      var startDateSelect = startDate < 10 ? '0' + startDate.toString() : startDate.toString()
      var endDateSelect = endDate < 10 ? '0' + endDate.toString() : endDate.toString()
      this.checkDate.push(startYear + '-' + monthStartSelect + '-' + startDateSelect)
      this.checkDate.push(endYear + '-' + monthEndSelect + '-' + endDateSelect)
      console.log('aaaaa', this.checkDate)
      this.getList(this.currentPage)
    },
    getList (currentPage, searchtype = '') {
      this.listShow = true
      this.common.stopScroll()
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        if (this.source !== '') {
          this.$router.push({name: 'login', query: {'source': this.source}})
        } else {
          this.$router.push({name: 'login'})
        }
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': this.orderno,
        'status': this.orderStatus,
        'type': this.dateType,
        'page': currentPage,
        'time': time,
        'currency': this.currency,
        'source': this.source,
        'token': token,
        'sessionid': sessionid
      }
      if (searchtype === 'search') {
        this.isSearch = true
        dataJson['checkin'] = this.checkDate[0]
        dataJson['checkout'] = this.checkDate[1]
      } else {
        this.isSearch = false
      }
      var data = this.common.encryptionData(dataJson, this)
      getTripList(data).then(res => {
        if (res.flag === '110') {
          this.$router.push({name: 'HotelList', query: {'source': this.source}})
        } else if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          if (this.source !== '') {
            this.$router.push({name: 'login', query: {'source': this.source}})
          } else {
            this.$router.push({name: 'login'})
          }
        } else if (res.flag === '200') {
          this.listInfo = res.data.list
          this.listTotal = parseInt(res.data.totalNum)
          this.currentPage = parseInt(res.data.currentPage)
          this.pageSize = parseInt(res.data.pageSize)
          this.tripEmptyShow = false
          this.listShow = false
        } else {
          this.listInfo = {}
          this.tripEmptyShow = true
          this.listShow = false
          this.currentPage = 1
          this.listTotal = 0
          this.pageSize = 20
        }
      })
      var query = JSON.parse(JSON.stringify(this.$route.query))
      query.currentPage = this.currentPage
      query.orderno = this.orderno
      query.orderStatus = this.orderStatus
      query.dateType = this.dateType
      if (searchtype === 'search' && this.dateType !== 'all') {
        query.checkin = this.checkDate[0]
        query.checkout = this.checkDate[1]
      } else {
        query.checkin = ''
        query.checkout = ''
      }
      this.$router.push({path: '/portal/account/MyTrip', query: query})
      this.common.canScroll()
    },
    gotoDetail (status, orderno, source, paystatus, key) {
      if (this.listInfo[key].waitingPayData !== '') {
        localStorage.setItem('orderData', JSON.stringify(this.listInfo[key].waitingPayData))
      }
      if ((status === 1 || status === '1') && (paystatus === 1 || paystatus === '1')) {
        this.$router.push({name: 'WritePay', query: {'orderno': orderno, 'source': source, 'showCancel': 1}})
      } else {
        this.$router.push({name: 'tripDetail', query: { 'orderno': orderno, 'source': source }})
      }
    },
    ordernoInput () {
      this.orderno = this.orderno.replace(/\s+/g, '')
    },
    exportData () {
      this.fullscreenLoading = true
      console.log('fullscreenLoading', this.fullscreenLoading)
      this.common.stopScroll()
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        if (this.source !== '') {
          this.$router.push({name: 'login', query: {'source': this.source}})
        } else {
          this.$router.push({name: 'login'})
        }
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'status': this.orderStatus,
        'type': this.dateType,
        'time': time,
        'currency': this.currency,
        'source': this.source,
        'token': token,
        'operation': 'exportData',
        'sessionid': sessionid,
        'checkin': this.checkDate[0],
        'checkout': this.checkDate[1]
      }
      var data = this.common.encryptionData(dataJson, this)
      exportData(data).then(res => {
        this.fullscreenLoading = false
        const url = window.URL.createObjectURL(new Blob([res]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', this.source + '.csv')
        document.body.appendChild(link)
        link.click()
      })
      this.common.canScroll()
    }
  }
}
</script>
<style type="text/css" scoped>
  /* .home-center{height: auto;} */
  body > .el-container {margin-bottom: 40px;}
  .el-container{display:block;}
  /* 搜索 */
  .search{ height:100px; background: #FFF; border-radius: 5px;}
  .search-info{ height: 48px; padding: 26px 15px;}
  /* orderno */
  .hotellist-region{float: left;margin-right:5px;}
  .hotellist-region input, .search-status input{background-color:rgba(255,255,255,1);background-image:url(/static/img/account/icon_u24.png);background-repeat:no-repeat;background-size: 20px;background-position: 12px center;padding: 0px 50px;width: 100%; height: 48px;font-size: 16px;opacity:1;}
  .hotellist-region /deep/ .el-input__inner:focus,.hotellist-region input:focus, .search-status /deep/ .el-input__inner:focus,.search-status input:focus{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}
  .hotellist-region /deep/ .el-input__inner{padding:0 53px;height: 48px; background-image: url(/static/img/account/icon_u24.png);background-repeat: no-repeat;background-size: 23px;background-position: 15px center;border: 1px solid #DCDFE6;}
  .hotellist-region /deep/ .el-popover--plain{width:100%;padding:0px;color: #FF6B6D;top: -33px;font-size:12px;height: 28px;line-height: 28px;z-index: 2001;text-align:center;}

  /* 订单状态 */
  .search-status{width:170px;float: left;margin-right:5px;}
  .search-status .el-select{width: 100% !important;}
  .search-status /deep/ .el-input__inner{height: 48px;border: 1px solid #DCDFE6;}

  /* 日期 */
  /deep/ .el-popper[x-placement^=bottom]{margin-top: 5px;}
  /deep/ .el-popper[x-placement^=top]{margin-bottom: 0px;}
  .hotellist-date-all /deep/ .el-input__inner{border: 1px solid #DCDFE6;}
  .hotellist-date-all /deep/ .el-input__inner:focus{box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}
  .hotellist-date-all /deep/ .el-input__inner:focus, /deep/ .hotellist-date-all input:focus{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}

  .hotellist-date-all{height:100%;width:260px;display:inline-block;vertical-align: top;cursor:pointer;position: relative;}
  .hotellist-date{padding: 0px;width: 30%; height: 48px;font-size: 16px;opacity:1;}
  .hotellist-date .hotellist-date-start{float:left;width: 37%;height: 100%;/*text-indent: 0.5rem;*/line-height: 27px; font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;  font-weight: 650; font-style: normal; color: #4F4C4C;font-size: 14px;}
  .hotellist-date .hotellist-date-start-left{width: 38%;}
  .hotellist-date .hotellist-date-start .hotellist-date-start-date{width: 100%;height: 24px;line-height: 28px;}
  .hotellist-date .hotellist-date-start .hotellist-date-start-week{width: 100%;height: 24px;font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;color: #999999;line-height: 18px;}
  .hotellist-date .hotellist-date-line{float:left;width:3%;height: 50%;line-height: 40px; text-align: right;}
  .hotellist-date .hotellist-date-line img{width: 65%;height: 100%;}
  .hotellist-date .hotellist-date-end{float:right;width: 38%;height: 100%;/*text-indent: 1rem;*/line-height: 27px; font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;  font-weight: 650; font-style: normal; color: #4F4C4C;font-size: 14px;}
  .hotellist-date .hotellist-date-end .hotellist-date-end-date{width: 100%;height: 24px;line-height: 28px;}
  .hotellist-date .hotellist-date-end .hotellist-date-end-week{width: 100%;height: 24px;font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;color: #999999;line-height: 18px;}
  .hotellist-date-all .hotellist-date-time-show{position:absolute;left:0px;top:0px;margin-top: 6px;}
  .el-range-editor.el-input__inner{display:inline-block;}
  .el-date-editor--daterange.el-input__inner{ width:100%;}
  .input-date-icon{background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 20px;background-position: 0px center;}
  /deep/ .hotellist-date .el-range-separator{display:none!important;}
  .hotellist-date .el-range__icon{margin-left:0px;}
  .hotellist-date-all .hotellist-date-show{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}
  .hotellist-date-mobile{width: 100%; height: 48px;font-size: 16px;opacity:1;}
  .date-inner{border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;margin: 0em;background-color:rgba(255,255,255,1);width: 100%; height: 48px;opacity:1; cursor: pointer;font-size: 12px;}
  .date-inner .date-inner-start{width: 49%;height: 100%;float:left;overflow:hidden;}
  .date-inner .date-inner-division{border-right: solid 1px #797979;width: 1%;height: 100%;line-height: 45px;float:left;overflow:hidden}
  .date-inner .date-inner-end{width: 49%;height: 100%;line-height: 45px;float:left;overflow:hidden;}
  .date-inner .date-inner-check-img{width: 40px;height: 100%;background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 20px;background-position: 10px center;float:left;}
  .date-inner .date-inner-check-info{height: 100%;width:55%;float:left;}
  .date-inner .date-inner-check-str{width: 100%;height: 50%;line-height: 30px;}
  .date-inner .date-inner-check-date{width: 100%;height: 50%;line-height: 17px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}
  /deep/ .el-range-editor.is-active, /deep/ .el-range-editor.is-active:hover, /deep/ .el-select .el-input.is-focus .el-input__inner{border-color:rgba(83, 102, 163, 1);}
  /deep/ .el-date-table td.end-date span, /deep/ .el-date-table td.start-date span{background-color: rgba(83, 102, 163, 1);}
  /* 按钮 */
  .input_button{ height: 48px !important; width: 7% !important; margin-left: 1% !important;}
  .view_button{margin: 15px 0 !important; width: 100px !important; height: 30px !important; float: right !important;}
  /deep/ .el-button{padding: 0;}
  /* 列表 */
  .trip-list{margin-top: 15px; background: #FFF; border-radius: 5px; padding:15px; position: relative;}
  .triplist{width: 98%; background-color: rgba(242, 242, 242, 1);height: 40px;border: none; font-weight: 650; font-size: 14px; color: #333333; line-height: 40px; padding: 0 1%;border-radius: 5px;}
  .triplist div, .hotel-info div{display:inline-block; float: left;}
  .hotel-info{width: 98%; min-height:60px;height: auto; line-height: 60px; border: none; color: #333333;padding: 0 1%;border-bottom: 1px solid #d2cfcf; clear: both; font-size: 14px;}
  .no-text-back{color: #C0C4CC !important;}
  .no-date{background-color: #F5F7FA !important;border-color: #E4E7ED !important;color: #C0C4CC !important;cursor: not-allowed;}
  .width-orderno-info{width: 18%;}
  .width-creation-info{width: 12%;}
  .orderno-info{width: 15%;}
  .creation-info{width: 15%;}
  .list-hotel-info{width: 22%;padding-right: 1%;}
  .guest-info{width: 10%;padding-right: 1%;}
  .check-info{width: 10%;}
  .price-info{width: 6%; padding-right: 2%; text-align: right;}
  .status-info{width: 8%;}
  .view-info{width: 10%;}
  /* 分页 */
  .account-data-page{width:100%;height:100px;text-align:right;margin-top: 40px; bottom: -30px;position: absolute;right: 1%;}
  .account-data-page-list{width:98%;height:100px;text-align:right;margin-top: 40px; margin-right: 2%;}
  .account-data-page .el-pagination.is-background .el-pager li,.account-data-page .el-pagination.is-background .btn-prev,.account-data-page .el-pagination.is-background .btn-next,  .account-data-page-list .el-pagination.is-background .el-pager li,.account-data-page-list .el-pagination.is-background .btn-prev,.account-data-page-list .el-pagination.is-background .btn-next{background:white; color: #333333;}
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active, /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{background-color:rgba(83, 102, 163, 1); color:#FFF;}
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover{color:white;background-color: rgba(83, 102, 163, 0.6);}
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active:hover{color: white;background-color: rgba(83, 102, 163, 1);}
  .el-pagination{padding: 0;}
  /* 骨架屏 */
  .template-text{width: 80%;margin: 13.5px 0;}
  .template-info-text{width: 80%;margin: 19px 0;}
  .trip-list /deep/ .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover, .hotel-info  /deep/ .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{box-shadow: none;}
  .trip-list /deep/ .el-card{border: none;}
  @media only screen and (max-width:1500px){
    /deep/ .el-popper[x-placement^=bottom]{left: 471px !important;}
  }

</style>



// WEBPACK FOOTER //
// src/components/account/myTrip.vue